import { render } from "./dispatch-builder.vue?vue&type=template&id=280e4806&scoped=true"
import script from "./dispatch-builder.vue?vue&type=script&lang=js"
export * from "./dispatch-builder.vue?vue&type=script&lang=js"

import "./dispatch-builder.vue?vue&type=style&index=0&id=280e4806&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280e4806"]])

export default __exports__